import { render, staticRenderFns } from "./CreateOrEditCompanyUser.vue?vue&type=template&id=1c629710&"
import script from "./CreateOrEditCompanyUser.vue?vue&type=script&lang=ts&"
export * from "./CreateOrEditCompanyUser.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports